<template>
  <div class="targetCustomerMatching">
    <el-row type="flex"
            class="row-bg targetCustomerMatching-heard"
            justify="space-between">

      <filter-panel class="filter-panel"
                    :data="swarchGroups"
                    @search="filterChange"
                    :simple="true">
      </filter-panel>
      <div class="row-bg rightHeader">
        <el-dropdown @command="handleCommand"
                     v-if="dasData.length">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in dasData"
                              :key="item.id"
                              :command="item">{{item.name}}</el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary"
                   @click="downloadTheReport"
                   v-if="isDownloadTheReport">
          下载报告
        </el-button>
      </div>
    </el-row>
    <el-col :span="24"
            class="google-list">
      <data-list style="margin-top: 10px;"
                 :page="page"
                 :table-style="{ name: 'mixture' }"
                 :data="data"
                 :columns="columns"
                 :loading="loading"
                 @page-size-changed="pageSizeChanged"
                 @page-changed="pageChanged"
                 @sort-change="sortChange"></data-list>
    </el-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import customer from '@/mixins/customer';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import serApi from '@/backend/services/account/service.js'
import blockList from '@/backend/pages/googleAds/components/blockList.vue';
import adsApi from '@/backend/services/googleAds/googleAds.js'
import { download2 } from '@/common/util.js';
import dayjs from 'dayjs'
const page = listPageCreate({
  searchConfig: {
    api: api.googleAds.industyList,
    method: 'POST',
    config: {
			timeout: 30000,
		},
  },
  getQuery (obj, _this) {
    obj.sortField = obj.sortName;
    delete obj.sortName;
    delete obj.customerId;
    return _.assign(obj);
  }
});
export default {
  name: 'targetCustomerMatching',
  components: {
    blockList,
    filterPanel,
  },
  computed: {
    ...mapGetters(['userInfo']),
    isDownloadTheReport (_this) {
      return _this.showButton('TCMDownloadTheReport')
    },
    dasData (_this) {
      let TCMAds = { id: '1', name: '数据同步Ads' };
      let TCMUpdateOfEligibility = { id: '2', name: '使用资格更新' };
      let isTCMAds = _this.showButton('TCMAds');
      let isTCMUpdateOfEligibility = _this.showButton('TCMUpdateOfEligibility')
      if (isTCMAds && isTCMUpdateOfEligibility) {
        return [TCMAds, TCMUpdateOfEligibility]
      } else {
        if (isTCMAds) {
          return [TCMAds]
        }
        if (isTCMUpdateOfEligibility) {
          return [TCMUpdateOfEligibility]
        }
        return []
      }
    },
    defaultDate (_this) {
      let today = new Date();
      let today_time = dayjs(today).format('YYYY-MM-DD');
      let old7Date = today.setDate(today.getDate() - 7);
      let old7Date_time = dayjs(old7Date).format('YYYY-MM-DD');
      return [old7Date_time, today_time]
    }
  },
  mixins: [customer, page],
  data () {
    let _this = this;
    return {
      contentList: {},
      cidNumber: '',
      columns: [
        {
          label: '外贸一级行业',
          bind: 'industryName',
          align: 'left',
          type: 'percentage',
          dataStyle (val) {
            return val || '-';
          },
        },
        {
          label: '当前邮箱规模',
          bind: 'totalMailboxSize',
          align: 'left',
          type: 'percentage',
          style: {
            textAlign: 'left',
          },
          dataStyle (val) {
            return val || '-';
          },
        },
        {
          label: '已获取资格数/总数(服务期内服务单)',
          width: 240,
          bind: 'onlineServiceHasQualifications',
          align: 'left',
          type: 'custInfo',
          style: {
            textAlign: 'left',
          },
          sort: 1,
          text: [
            {
              label: '',
              bind: 'onlineServiceHasQualifications',
              custValue (val) {
                return `${val.onlineServiceHasQualifications}/${val.onlineServiceTotal}`
              },
            },
            {
              label: '',
              bind: 'onlineServicePercentage',
              custValue (val) {
                return `${val.onlineServicePercentage}%`
              },
              style: {
                'font-size': '20px',
              }
            }
          ],
          options: [
            {
              label: '由低到高',
              value: 1,
            },
            {
              label: '由高到低',
              value: 2,
            },
          ],
        },
        {
          label: '已获取资格数/总数',
          labelFn () {
            return `已获取资格数/总数(全部服务单)`
          },
          width: 220,
          bind: 'status',
          align: 'left',
          type: 'custInfo',
          style: {
            textAlign: 'left',
          },
          sort: 2,
          options: [
            {
              label: '由低到高',
              value: 1,
            },
            {
              label: '由高到低',
              value: 2,
            },
          ],
          text: [
            {
              label: '',
              bind: 'serviceHasQualifications',
              custValue (val) {
                return `${val.serviceHasQualifications}/${val.serviceTotal}`
              },
            },
            {
              label: '',
              bind: 'servicePercentage',
              custValue (val) {
                return `${val.servicePercentage}%`
              },
              style: {
                'font-size': '20px',
              }
            }
          ],
        },
        {
          label: '新增邮箱规模',
          sort: 3,
          bind: 'newMailboxSizeTotal',
          align: 'left',
          type: 'percentage',
          style: {
            textAlign: 'left',
          },
          dataStyle (val) {
            return val || '-';
          },
          options: [
            {
              label: '由低到高',
              value: 1,
            },
            {
              label: '由高到低',
              value: 2,
            },
          ],
        },
        {
          label: '新增资格数',
          sort: 4,
          bind: 'newQualifications',
          align: 'left',
          type: 'percentage',
          style: {
            textAlign: 'left',
          },
          dataStyle (val) {
            return val || '-';
          },
          options: [
            {
              label: '由低到高',
              value: 1,
            },
            {
              label: '由高到低',
              value: 2,
            },
          ],
        },
        {
          label: '最后更新时间',
          sort: 5,
          bind: 'lastUpdateTime',
          align: 'left',
          type: 'percentage',
          style: {
            textAlign: 'left',
          },
          dataStyle (val) {
            return val || '-';
          },
          options: [
            {
              label: '由远到近',
              value: 1,
            },
            {
              label: '由近到远',
              value: 2,
            },
          ],
        },
        {
          label: '操作',
          type: 'btnClick',
          align: 'left',
          style: 'text',
          width: 200,
          bind () {
            return [
              {
                text: '下载行业包',
                trigger (row) {
                  _this.downloadIndustryPackages(row)
                },
                showButton () {
                  return _this.showButton('TCMDownloadIndustryPackages')
                },
              },
              {
                text: '查看详情',
                trigger (row) {
                  _this.$router.push({
                    name: 'industryPackageDetails',
                    query: {
                      industryId: row.industryId,
                    },
                  });
                },
                showButton () {
                  return _this.showButton('TCMViewDetails')
                }
              },
            ];

          },
        },
      ],
      swarchGroups: {
        others: [
          {
            tagName: 'sky-select',
            placeholder: '选择外贸一级行业',
            prop: 'industryName',
            props: {
              label: 'name',
              value: 'name',
            },
            value: '',
            options: [],
          },
          {
            tagName: 'sky-date-picker',
            type: 'daterange',
            label: '日期筛选',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            prop: ['startDate', 'endDate'],
            value: [],
            clearable: false,
            pickerOptions: {
              disabledDate (time) {
                return time.getTime() > Date.now()
              }
            }
          },
        ],
      },
    };
  },
  methods: {
    requestData () {
      this.query();
      this.getIndustryList()
    },
    showButton (pamis) {
      return this.getPermission(this.$permissionData[pamis].englishName)
    },
    async getIndustryList () {
      try {
        let res = await serApi.getIndustryList({ parentId: '0' })
        if (res.status >= 200 && res.status < 400) {
          this.swarchGroups.others[0].options = res.data
        }
      } catch (e) {
        console.error(e)
      }
    },
    // 更多操作下拉
    handleCommand (command) {
      switch (command.id) {
        case '1':
          this.adsDataSynchronism()
          break;
        case '2':
          this.updateOfEligibilityRegulation();
          break;
        case '3':
          this.mailboxScaleUpdate()
          break;
      }
    },
    async updateOfEligibilityRegulation () {
      let res = await adsApi.updateOfEligibilityRegulation();
      if (res) {
        this.$message.success(`资格监控更新成功`);
        this.query();
      }
    },
    async downloadTheReport () {
      this.downloading = true;
      let res = await adsApi.downloadTheReport();
      this.downloading = false;
      download2(res.data, `下载报告.xlsx`);
      this.downloading = false;
    },
    async downloadIndustryPackages (row) {
      this.downloading = true;
      let res = await adsApi.downloadIndustryPackages({ industryId: row.industryId });
      this.downloading = false;
      download2(res.data, `下载行业包.xlsx`);
      this.downloading = false;
    },
    async mailboxScaleUpdate () {
      let res = await adsApi.mailboxScaleUpdate();
      if (res) {
        this.$message.success(`邮箱规模更新成功`);
        this.query();
      }
    },
    async adsDataSynchronism () {
      let control = await this.$confirmShow(`是否确定同步?`, '数据同步到Ads')
      if (control) {
        let res = await adsApi.industryPackageAllAds();
        if (res) {
          this.$message.success(`数据同步成功`);
          this.query();
        }
      }
    },
  },
  mounted () {
    this.swarchGroups.others[1].value = this.defaultDate
    this.requestData();
  },
};
</script>

<style scoped lang="scss">
.rightHeader {
	display: flex;
	width: 232px;
	justify-content: space-around;
	padding-right: 0px;
	align-items: center;
}
.textStyle {
	text-align: center;
	height: 40px;
	line-height: 40px;
}
</style>
